export const namespace = 'vtn-app-user-permissions';

export interface PermissionsStoreSlice {
  readonly [namespace]: PermissionsState;
}

export interface PermissionsState {
  readonly allowDownload: Permission;
  readonly allowUpload: Permission;
  readonly allowNoUploadSizeLimit: Permission;
  readonly allowRunRedaction: Permission;
  readonly allowRunDetection: Permission;
  readonly allowRunTranscription: Permission;
}

export type Permission<Effects = unknown> =
  | [boolean, number]
  | [boolean, number, () => IterableIterator<Effects>];

export const defaultPermissionsState: PermissionsState = {
  allowDownload: [true, 0],
  allowUpload: [true, 0],
  allowNoUploadSizeLimit: [true, 0],
  allowRunRedaction: [true, 0],
  allowRunDetection: [true, 0],
  allowRunTranscription: [true, 0],
};
